var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[(_vm.loggedIn)?_c('b-nav-item',{attrs:{"id":"signout","variant":"warning"},on:{"click":_vm.signout}},[_vm._v(" Sign out ")]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }